import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import { Button, Col, Dropdown, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import ReusableTable from "../../components/ReusableTable";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { useSelector } from "react-redux";

const Outlets = () => {
    const navigate = useNavigate();
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);

    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [outletAccess, setOutletAccess] = useState([]);

    console.log("Access :", access);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("Outlet:")
            );
            setOutletAccess(filteredAccess);
        }
    }, [access]);

    console.log("Outlet Access:", outletAccess);

    const accessToken = localStorage.getItem("authToken");
    const [outlets, setOutlets] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [openUpdateImageModal, setOpenUpdateImageModal] = useState(false);
    const [outletImageId, setOutletImageId] = useState('');
    const [dataLoading, setDataLoading] = useState(false);
    const [isUpdateImageBtnLoading, setIsUpdateImageBtnLoading] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [outletDetails, setOutletDetails] = useState({});
    const [editedOutletImage, setEditedOutletImage] = useState(false);
    const [groups, setGroups] = useState([]);
    const [menuGroup, setMenuGroup] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [searchData, setSearchData] = useState({
        city: "",
        pincode: "",
        status: "",
        menuGroup
    });
    const [searchText, setSearchText] = useState('');
    const [center, setCenter] = useState({
        name: "",
        lat: 17.9104,
        lng: 77.5199,
    });
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showBtnLoading, setShowBtnLoading] = useState(false);

    const containerStyle = {
        width: '80%',
        height: '350px',
        margin: '20px auto'
    };

    const updateCenter = (newLat, newLng) => {
        if (typeof newLat === 'number' && typeof newLng === 'number') {
            setCenter({
                lat: newLat,
                lng: newLng,
            });
        } else {
            console.error('Invalid latitude or longitude:', newLat, newLng);
        }
    };

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyATjJP7Zx7lNzU-dRY9dLNTY29TfUHXPJo'
    })

    const [map, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map)
    }, [center.lat, center.lng])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const formatTime = (time) => {
        if (!time) return '';

        let [hours, minutes] = time.split(':');
        hours = parseInt(hours, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        minutes = minutes?.padStart(2, '0');

        return `${hours}:${minutes} ${ampm}`;
    };

    const columns = [
        { header: "Sr.No", accessor: "serialNumber" },
        {
            header: "Outlet Name",
            accessor: "name",
            render: (value, row) => (
                <div className="d-flex align-items-center gap-2">
                    <div className="avatar">
                        <img src={row.outletImage} alt="Outlet" />
                    </div>
                    <div>
                        <h6 className="mb-0" style={{ fontSize: "0.85rem" }}>{value}</h6>
                        <span className="fs-xs text-secondary" style={{ fontSize: "0.7rem" }}>{row.email}</span>
                        <span
                            className={`badge ${row.type === "COMPANY_OWNED"
                                ? "bg-primary"
                                : row.type === "FRANCHISE"
                                    ? "bg-success"
                                    : row.type === "EVENT"
                                        ? "bg-warning text-dark"
                                        : "bg-secondary"
                                }`}
                            style={{ fontSize: "0.65rem" }}
                        >
                            {row.type}
                        </span>
                    </div>
                </div>
            ),
        },
        {
            header: "Menu Group", accessor: "menuGroup",
            render: (value, row) => (
                <div>
                    <span style={{ fontSize: '0.75rem' }} className={row?.menuGroup ? 'text-success' : 'text-danger'}>{row?.menuGroup ? row?.menuGroup?.groupName : "No Menu Allocated"}</span>
                </div>
            )
        },
        {
            header: "Contact", accessor: "phone",
            render: (value, row) => (
                <div>
                    <span className='text-primary' style={{ fontSize: "0.85rem" }}>{value}</span>
                </div>
            )
        },
        {
            header: "City",
            accessor: "city",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0" style={{ fontSize: "0.85rem" }}>{value}</h6>
                    <span className="fs-xs text-secondary" style={{ fontSize: "0.7rem" }}>{row.pincode}</span>
                </div>
            ),
        },
        {
            header: "State & Country",
            accessor: "state",
            render: (value, row) => (
                <div>
                    <h6 className="mb-0" style={{ fontSize: "0.85rem" }}>{value}</h6>
                    <span className="fs-xs text-secondary" style={{ fontSize: "0.7rem" }}>{row.country}</span>
                </div>
            ),
        },
        {
            header: "Status & Order Type",
            accessor: "status",
            render: (value, row) => (
                <>
                    <span
                        style={{
                            justifyContent: 'center',
                            display: 'flex',
                            color: row?.orderAcceptType === "PICKUP" ? 'blueviolet'
                                : row?.orderAcceptType === "DELIVERY" ? 'brown'
                                    : 'darkmagenta',
                            fontSize: "0.75rem"
                        }}
                        className="mb-0 pb-0"
                    >
                        {row?.orderAcceptType}
                    </span>
                    <span
                        className={`badge ${value === "ACTIVE"
                            ? "bg-success"
                            : value === "COMING_SOON"
                                ? "bg-warning"
                                : "bg-danger"
                            }`}
                        style={{ fontSize: "0.7rem" }}
                    >
                        {value}
                    </span>
                </>
            ),
        },
        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <div className="d-flex justify-content-center">
                    <Dropdown>
                        <Dropdown.Toggle variant="link" className="p-0 m-0 border-0">
                            <i className="ri-more-2-fill" style={{ cursor: "pointer", fontSize: "1rem" }}></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            {(outletAccess?.includes("Outlet:update") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-primary"
                                    onClick={() => handleEdit(row)}
                                    style={{ fontSize: "0.8rem" }}
                                >
                                    Edit
                                </Dropdown.Item>
                            )}
                            {(outletAccess?.includes("Outlet:get") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-success"
                                    onClick={() => handleOpenViewModal(row)}
                                    style={{ fontSize: "0.8rem" }}
                                >
                                    View
                                </Dropdown.Item>
                            )}
                            {(outletAccess?.includes("Outlet:delete") || email === 'contact@xpansecafe.com') && (
                                <Dropdown.Item
                                    className="text-danger"
                                    onClick={() => handleDeleteModal(row)}
                                    style={{ fontSize: "0.8rem" }}
                                >
                                    Delete
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const getOutlets = async () => {
        setDataLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("outlet", { headers });

            if (response?.data?.status === true) {
                response?.data?.data?.outlets.forEach((item, index) => {
                    item.serialNumber = index + 1;
                });

                setOutlets(response?.data?.data?.outlets);
                setFilteredData(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setDataLoading(false);
        }
    };

    const getMenuGroup = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("menu-group", { headers });
            if (response?.data?.status === true) {
                setGroups(response?.data?.data?.menuGroup);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage);
            }
        }
    };

    const getSingleOutletDetails = async (outletId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get(`outlet?_id=${outletId}`, { headers });

            if (response?.data?.status === true) {
                setOutletDetails(response?.data?.data?.outlets);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleOpenImageChangeModal = (id) => {
        setOpenImageModal(false)
        setOpenUpdateImageModal(true);
        setOutletImageId(id);
    }

    const handleOpenAddModal = () => {
        navigate('/outlet-management/add-outlet');
    };

    const handleEdit = (data) => {
        navigate(`/outlet-management/edit-outlet/${data._id}`, { state: { outletData: data } });
    };

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setCategoryId(data?._id);
    };

    const deleteOutlet = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: categoryId,
            };
            const response = await axios.delete(`outlet`, { data, headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getOutlets();
                setOpenDeleteModal(false);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsDeleteLoading(false);
        }
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setSearchData((prev) => ({ ...prev, [name]: value }))
    };

    const handleOpenViewModal = (data) => {
        const newLat = parseFloat(data?.coordinates?.latitude);
        const newLng = parseFloat(data?.coordinates?.longitude);
        if (!isNaN(newLat) && !isNaN(newLng)) {
            updateCenter(newLat, newLng);
            setCenter((prev) => ({ ...prev, name: data.name }))
            setOpenViewModal(true);
            getSingleOutletDetails(data?._id);
        } else {
            console.error('Invalid coordinates:', data?.coordinates);
        }
    }

    const handleFilterSubmit = async (e) => {
        setShowBtnLoading(true);
        setDataLoading(true);
        e.preventDefault();
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let url = `outlet/getOutletCityPincode`;

            const params = new URLSearchParams();

            if (searchData?.city) {
                params.append("city", searchData.city);
            }

            if (searchData?.pincode) {
                params.append("pincode", searchData.pincode);
            }

            if ([...params].length > 0) {
                url += `?${params.toString()}`;
            }
            const response = await axios.get(url, { headers });
            if (response?.data?.status === true) {
                const totalRecords = response?.data?.data?.totalOutletRecords;
                setFilteredData(totalRecords)
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if ( error.response?.status === 406 ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if ( error.response?.status === 412 ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setShowBtnLoading(false);
            setDataLoading(false);
        }
    };

    const handleEditImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const image = new Image();
                image.src = reader.result;

                image.onload = () => {
                    const width = image.width;
                    const height = image.height;
                    const maxWidth = 1410;
                    const maxHeight = 1100;

                    if (width === maxWidth && height === maxHeight) {
                        setEditedOutletImage(file);
                    } else {
                        alert(
                            `Invalid image dimensions. Please upload an image with dimensions ${maxWidth}x${maxHeight}.`
                        );
                        e.target.value = "";
                    }
                };
            };

            reader.readAsDataURL(file);
        }
    };

    const handleUpdateImage = async (e) => {
        e.preventDefault();
        setIsUpdateImageBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }
            const formData = new FormData();
            formData.append('outletImage', editedOutletImage);
            formData.append('_id', outletImageId);
            const response = await axios.put("outlet", formData, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
                getOutlets();
                setOpenUpdateImageModal(false);
                setOpenViewModal(false);
            }

        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (
                    error.response?.status === 406
                ) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
                }
                else if (
                    error.response?.status === 412
                ) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        } finally {
            setIsUpdateImageBtnLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPage(1);
        setRowsPerPage(rowsPerPage);
    };

    const getPaginatedData = () => {
        const startIndex = (page - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return filteredData?.slice(startIndex, endIndex);
    };

    useEffect(() => {
        const result = outlets.filter((item) => {
            return (
                item.name.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.email.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.phone.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.address.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.pincode.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.city.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.state.toLowerCase().match(searchText.toLocaleLowerCase()) ||
                item.country.toLowerCase().match(searchText.toLocaleLowerCase())
            );
        });
        setFilteredData(result);
    }, [searchText]);

    useEffect(() => {
        if (searchData?.city === "" && searchData?.pincode === "") {
            getOutlets();
        }
    }, [searchData?.city, searchData?.pincode]);

    useEffect(() => {
        getOutlets();
        getMenuGroup();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div
                    className="container shadow-sm"
                    style={{ backgroundColor: "white" }}
                >
                    <Row className="pt-4">
                        <Col>
                            <h5 className="fw-semibold" style={{ fontSize: "1.1rem" }}>OUTLET MANAGEMENT</h5>
                        </Col>
                        <hr />
                    </Row>
                    <Row className="mb-3">
                        <Col md={2}>
                            <Form.Group>
                                <Form.Label className="small fw-semibold" style={{ fontSize: "0.75rem" }}>Menu Group <span className="text-danger">*</span></Form.Label>
                                <Form.Select
                                    name="menuGroup"
                                    value={searchData?.menuGroup}
                                    onChange={handleFilterChange}
                                    required
                                    style={{ fontSize: "0.85rem" }}
                                >
                                    <option value="">Select menu</option>
                                    {groups.map(group => (
                                        <option key={group._id} value={group._id}>{group.groupName}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col lg={2}>
                            <Form.Label className="fw-semibold" style={{ fontSize: "0.75rem" }}>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={searchData?.status}
                                onChange={handleFilterChange}
                                required
                                style={{ fontSize: "0.85rem" }}
                            >
                                <option value="">Select status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                                <option value="COMING_SOON">Coming Soon</option>
                            </Form.Select>
                        </Col>
                        <Col lg="2">
                            <Form.Label className="fw-semibold" style={{ fontSize: "0.75rem" }}>City</Form.Label>
                            <Form.Control placeholder="Enter City" type="text" name="city" onChange={handleFilterChange} value={searchData.city} style={{ fontSize: "0.85rem" }} />
                        </Col>

                        {/* <Col lg="2">
                            <Form.Label className="fw-semibold" style={{ fontSize: "0.75rem" }}>Pincode</Form.Label>
                            <Form.Control placeholder="Enter Pincode" type="text" name="pincode" onChange={handleFilterChange} value={searchData.pincode} style={{ fontSize: "0.85rem" }} />
                        </Col> */}
                        {/* <Col lg="2">
                            <Form.Label className="fw-semibold">Menu Group</Form.Label>
                            <Form.Control placeholder="Select Menu Group" type="select" name="pincode" onChange={handleFilterChange} value={searchData.pincode} />
                        </Col> */}

                        <Col lg="2" className="d-flex justify-content-end flex-column">
                            <Button variant="success" className="fw-semibold"
                                // disabled={!(searchData.pincode && searchData.city)} 
                                onClick={handleFilterSubmit} style={{ fontSize: "0.85rem" }}>
                                {showBtnLoading ? <Spinner size="sm" /> : "Show"}
                            </Button>
                        </Col>
                        <Col>
                            <div>
                                <Form.Label className="text-white">.</Form.Label>
                            </div>
                            <div className="input-group w-100">
                                <input
                                    type="text"
                                    value={searchText}
                                    onChange={handleSearchChange}
                                    className="form-control"
                                    placeholder="Search for outlets..."
                                    style={{ fontSize: "0.85rem" }}
                                />
                                <button className="btn btn-primary" type="button" style={{ fontSize: "0.85rem" }}>
                                    <i className="ri-search-line"></i>
                                </button>
                            </div>
                        </Col>
                        <Col lg="2" className="d-flex justify-content-end flex-column">
                            <Form.Label className="text-white">.</Form.Label>
                            <Button
                                variant="primary"
                                className="fw-semibold"
                                onClick={handleOpenAddModal}
                                style={{ fontSize: "0.85rem" }}
                            >
                                <i className="ri-add-line" style={{ marginRight: "5px" }}></i>
                                Add New Outlet
                            </Button>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {(outletAccess?.includes("Outlet:get") || email === 'contact@xpansecafe.com') && (
                                <ReusableTable
                                    columns={columns}
                                    data={getPaginatedData()}
                                    rowKey="serialNumber"
                                    loading={dataLoading}
                                    currentPage={page}
                                    recordsPerPage={rowsPerPage}
                                    onPageChange={handlePageChange}
                                    totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                                    onRecordsPerPageChange={handleRowsPerPageChange}
                                />
                            )}
                        </Col>
                    </Row>

                    {/* <------------- View Outlets Modal ------------> */}
                    {openViewModal ? (
                        <Modal
                            size="xl"
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            centered
                            aria-labelledby="profile-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="profile-modal" style={{ fontSize: "1rem" }}>Outlet Profile</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row className="align-items-center">
                                    <Col md={4} className="text-center">
                                        <img
                                            src={outletDetails?.outletImage}
                                            alt="outlet-img"
                                            className="img-fluid rounded-circle mb-3"
                                            style={{ width: "180px", height: "180px", objectFit: "cover" }}
                                        />
                                        <Button
                                            variant="primary"
                                            className="w-100"
                                            style={{ marginTop: '60px', fontSize: "0.85rem" }}
                                            onClick={() => handleOpenImageChangeModal(outletDetails?._id)}
                                        >
                                            Change Image
                                        </Button>
                                    </Col>

                                    <Col md={8}>
                                        <h5 className="fw-bold mb-3" style={{ fontSize: "1rem" }}>Outlet Details</h5>
                                        <Table borderless className="mb-4" style={{ fontSize: "0.85rem" }}>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Name</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Email</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.email}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Phone</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.phone}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Address</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.address}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>City</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.city}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Pincode</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.pincode}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>State</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.state}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Country</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.country}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>GST</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.gstin}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>FSSAI</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.fssai || 'Not Provided'}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <hr />
                                <Row className="mt-4">
                                    <Col>
                                        <h5 className="fw-bold" style={{ fontSize: "1rem" }}>Status & Timing</h5>
                                        <Table borderless style={{ fontSize: "0.85rem" }}>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Outlet Type</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails ? outletDetails?.type : 'Will Be Updated Soon'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Accepting Orders IN</td>
                                                    <td
                                                        className={`fw-bold ${outletDetails?.orderAcceptType === "PICKUP"
                                                            ? "text-danger"
                                                            : outletDetails?.orderAcceptType === "DELIVERY"
                                                                ? "text-success"
                                                                : ""
                                                            }`}
                                                        style={{ fontSize: "0.85rem" }}
                                                    >
                                                        {outletDetails?.orderAcceptType}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Status</td>
                                                    <td
                                                        className={`fw-bold ${outletDetails?.status === "INACTIVE"
                                                            ? "text-danger"
                                                            : "text-success"
                                                            }`}
                                                        style={{ fontSize: "0.85rem" }}
                                                    >
                                                        {outletDetails?.status}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Minimum Radius For Delivery</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.minimumDeliveryRadius ? `${outletDetails?.minimumDeliveryRadius} Kms` : "Not Provided"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Opening Time</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{formatTime(outletDetails?.openingTime)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Closing Time</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{formatTime(outletDetails?.closingTime)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Is Outlet Closed</td>
                                                    <td
                                                        className={`fw-bold ${outletDetails?.isOutletClosed ? "text-danger" : "text-success"
                                                            }`}
                                                        style={{ fontSize: "0.85rem" }}
                                                    >
                                                        {outletDetails?.isOutletClosed ? "CLOSED" : "OPEN"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Outlet Type</td>
                                                    <td style={{ color: "brown", fontSize: "0.85rem" }}>
                                                        {outletDetails?.isEventOutlet
                                                            ? "Event Outlet"
                                                            : "Regular Outlet"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Menu Group</td>
                                                    <td className="fw-semibold" style={{ fontSize: "0.85rem" }}>
                                                        {outletDetails?.menuGroup
                                                            ? outletDetails?.menuGroup?.groupName : "ALL GROUPS"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Food Unit</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.foodUnitId || 'Not Assigned'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Beverage Unit</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.beverageUnitId || 'Not Assigned'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Central Unit</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.centralUnitId || 'Not Assigned'}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col>
                                        <h5 className="fw-bold" style={{ fontSize: "1rem" }}>Payment Method Details</h5>
                                        <Table borderless style={{ fontSize: "0.85rem" }}>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Payment Type</td>
                                                    <td style={{ fontSize: "0.85rem" }}>{outletDetails?.paymentType}</td>
                                                </tr>
                                                {outletDetails?.paymentType === "CARD_SWIPE" ? (
                                                    <>
                                                        <tr>
                                                            <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Merchant Id</td>
                                                            <td style={{ fontSize: "0.85rem" }}>{outletDetails?.pineLabCredentials?.merchantId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Client Id</td>
                                                            <td style={{ fontSize: "0.85rem" }}>{outletDetails?.pineLabCredentials?.clientId}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Security Token</td>
                                                            <td style={{ fontSize: "0.85rem" }}>{outletDetails?.pineLabCredentials?.securityToken}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="fw-bold" style={{ fontSize: "0.85rem" }}>Store Id</td>
                                                            <td style={{ fontSize: "0.85rem" }}>{outletDetails?.pineLabCredentials?.storeId}</td>
                                                        </tr>
                                                    </>
                                                ) : null}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <hr />
                                {outletDetails?.platForms?.length > 0 && (
                                    <Row className="mt-4">
                                        <Col>
                                            <h5 className="fw-bold" style={{ fontSize: "1rem" }}>Delivery Platforms</h5>
                                            <Table striped bordered hover className="text-center" style={{ fontSize: "0.85rem" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ fontSize: "0.85rem" }}>Platform Name</th>
                                                        <th style={{ fontSize: "0.85rem" }}>Platform Weblink</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {outletDetails?.platForms?.map((platform, index) => (
                                                        <tr key={index}>
                                                            <td style={{ fontSize: "0.85rem" }}>{platform.name}</td>
                                                            <td style={{ fontSize: "0.85rem" }}>
                                                                <a
                                                                    href={platform.webLink}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    style={{ fontSize: "0.85rem" }}
                                                                >
                                                                    {platform.webLink}
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                )}

                                {isLoaded && (
                                    <Row className="mt-4">
                                        <Col>
                                            <h5 className="fw-bold" style={{ fontSize: "1rem" }}>Location</h5>
                                            <div style={{ width: "100%", height: "400px" }}>
                                                <GoogleMap
                                                    mapContainerStyle={containerStyle}
                                                    center={center}
                                                    zoom={10}
                                                    onLoad={onLoad}
                                                    onUnmount={onUnmount}
                                                >
                                                    <MarkerF position={center} title={center.name} />
                                                </GoogleMap>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    onClick={() => setOpenViewModal(false)}
                                    style={{ fontSize: "0.85rem" }}
                                >
                                    CLOSE
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    ) : null}

                    {/* <------------- Update Image Modal ------------> */}
                    {openUpdateImageModal ? (
                        <Modal
                            centered
                            show={openUpdateImageModal}
                            onHide={() => setOpenUpdateImageModal(false)}
                            aria-labelledby="update-image-modal"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="update-image-modal" className="fs-6" style={{ fontSize: "0.9rem" }}>
                                    UPDATE IMAGE
                                </Modal.Title>
                            </Modal.Header>
                            <Form onSubmit={handleUpdateImage}>
                                <Modal.Body>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Label style={{ fontSize: "0.85rem" }}>
                                            Choose File <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="file"
                                            onChange={handleEditImageChange}
                                            className="form-control"
                                            style={{ fontSize: "0.85rem" }}
                                        />
                                        <Form.Text className="text-success" style={{ fontSize: "0.7rem" }}>
                                            Choose an image with dimensions equal to 1410x1100
                                        </Form.Text>
                                    </Form.Group>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="rounded-pill"
                                        disabled={isUpdateImageBtnLoading}
                                        style={{ fontSize: "0.85rem" }}
                                    >
                                        {isUpdateImageBtnLoading ? <Spinner size="sm" /> : "Save Changes"}
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        </Modal>
                    ) : null}

                    {/* <---------------- Delete Outlet Modal ------------> */}
                    <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title style={{ fontSize: "1rem" }}>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ fontSize: "0.9rem" }}>
                            Are you sure you want to delete this outlet? This action cannot be undone.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal} style={{ fontSize: "0.85rem" }}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={deleteOutlet} style={{ fontSize: "0.85rem" }}>
                                {isDeleteLoading ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> :
                                    "Delete Outlet"
                                }
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Outlets;